module.exports = __webpack_public_path__ + "img/obtawhicon3.f19b5832.png";